export const truncate = (str: string, maxLength: number, suffix: string = '...') => {
  return str.length > maxLength ? `${str.slice(0, maxLength)}${suffix}` : str;
};

